<template>
    <div class="content-wrapper">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <app-breadcrumb
            page-title="Plan de Acción"
            directory="Revisión del plan de acción"
            :icon="'trello'"
          />
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
            <button
              type="button"
              class="btn btn-primary btn-with-shadow"
              @click="returnPage()"
            >
              {{ $t("back") }}
            </button>
            <!-- <button
              type="button"
              class="btn btn-success btn-with-shadow ml-3"
              @click="openDeleteModal"
            >
              Procesar
            </button> -->
          </div>
        </div>
  
        <div class="col-md-12">
          <app-tab :tabs="tabsHorizontal" type="horizontal" />
        </div>
      </div>
  
      <app-confirmation-modal
        v-if="deleteConfirmationModalActive"
        :preloader="deleteLoader"
        modal-id="modal-confirm-id"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="POR FAVOR ASEGÚRESE DE CARGAR EL FORMATO VIGENTE, QUE LO PUEDE ENCONTRAR  EN LA PARTE SUPERIOR DE ESTA INTERFAZ"
        message="¿Desea procesar este registro?"
        firstButtonName="Aceptar"
        secondButtonName="Cancelar"
        modalClass="success"
        icon="cpu"
      />
    </div>
  </template>
  
  <script>
  import * as actions from "../../apiUrl"
  import { axiosPost } from "@/app/helpers/AxiosHelper";
  import { FormMixin } from "@/core/mixins/form/FormMixin.js";
  export default {
    mixins: [FormMixin],
    props: {
      evalTestId: String,
    },
    data() {
      return {
        app_type: "",
        icon: "settings",
        tabsHorizontal: [
          {
            icon: "briefcase",
            name: "Revisión del Plan de Acción",
            component: "edit-revision-action-plan",
            permission: "",
          },
        ],
        deleteConfirmationModalActive: false,
        deleteLoader: false,
      };
    },
    created() {
      this.$store.state.evaluatorReview.evalTestId = this.evalTestId;
      localStorage.setItem("evalId", this.evalTestId);
      this.data();
    },
    methods: {
      returnPage() {
        window.location.href = `${actions.REVISION_ACTION_PLAN}/?tab=Revisión del Plan de Acción`;
      },
      data() {
        this.$store.dispatch("getEvalTest");
      },
      openDeleteModal() {
        this.deleteConfirmationModalActive = true;
      },
  
      confirmed() {
        this.deleteLoader = true;
        const url = `${actions.REVISION_ACTION_PLAN}/process?evalTestId=${this.evalTestId}`;
        const data = {
          additional_evidence: this.additional_evidence,
          corrective_actions_reject_counter: this.$store.state.evaluatorReview
            .evalTest.corrective_actions_reject_counter,
        };
        axiosPost(url, data)
          .then(({ data: res }) => {
            this.deleteLoader = false;
            $("#modal-confirm-id").modal("hide");
            this.cancelled();
            if (res.data === "OK") {
              this.$toastr.s("Registro procesado con exito");
              this.returnPage();
            } else {
              this.$toastr.e(res.data);
            }
          })
          .catch(({ error }) => {});
      },
  
      cancelled() {
        this.deleteConfirmationModalActive = false;
      },
    },
  };
  </script>
  